;(function ($) {
  $(document).ready(function () {
    $('input[type="password"].password-strength-indicator').password({
      minimumLength: 6,
    })
  })
})(jQuery)
